import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import api from "../../api/axiosClient";
import { useAuth } from "../../context/AuthContext";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800;900&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.hl-root {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-family: 'Raleway', sans-serif;
  background: #ffffff;
}

/* ───────────────── LEFT PANEL ───────────────── */

.hl-left {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 56px 60px;
  overflow: hidden;

  background:
    linear-gradient(
      rgba(0,0,0,0.70),
      rgba(0,0,0,0.70)
    ),
    url('https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1600&auto=format&fit=crop')
    center center/cover no-repeat;
}

.hl-headline {
  position: relative;
  z-index: 1;

  font-size: clamp(2rem, 3vw, 2.8rem);
  font-weight: 900;
  color: #fff;

  line-height: 1.1;
  margin-bottom: 18px;
  letter-spacing: -.03em;
}

.hl-headline em {
  font-style: italic;
  color: #fff000;
  font-weight: 800;
}

.hl-desc {
  position: relative;
  z-index: 1;

  font-size: .9rem;
  color: rgba(255,255,255,.82);

  line-height: 1.85;
  max-width: 380px;
  margin-bottom: 48px;
  font-weight: 400;
}

.hl-perks {
  position: relative;
  z-index: 1;

  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.hl-perk {
  display: flex;
  align-items: center;
  gap: 11px;

  font-size: .82rem;
  color: rgba(255,255,255,.88);
  font-weight: 500;
}

.hl-tick {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;

  background: rgba(255,240,0,.14);
  border: 1.5px solid rgba(255,240,0,.35);

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: .5rem;
  color: #fff000;
}

/* ───────────────── RIGHT PANEL ───────────────── */

.hl-right {
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 68px;
}

.hl-box {
  width: 100%;
  max-width: 420px;
}

.hl-title {
  font-size: 2rem;
  font-weight: 900;
  color: #000000;

  margin-bottom: 5px;
  letter-spacing: -.03em;
}

.hl-sub {
  font-size: .84rem;
  color: #64748b;

  margin-bottom: 32px;
  font-weight: 500;
}

.hl-err {
  background: #fef2f2;
  border: 1.5px solid #fecaca;
  border-radius: 10px;

  padding: 11px 14px;
  margin-bottom: 20px;

  font-size: .8rem;
  color: #b91c1c;

  display: flex;
  align-items: center;
  gap: 8px;

  font-weight: 600;
}

.hl-field {
  margin-bottom: 18px;
}

.hl-lbl {
  display: block;

  font-size: .68rem;
  font-weight: 700;

  text-transform: uppercase;
  letter-spacing: .08em;

  color: #475569;
  margin-bottom: 7px;
}

.hl-inp {
  width: 100%;
  padding: 13px 15px;

  font-size: .9rem;
  font-weight: 500;

  border: 2px solid #e2e8f0;
  border-radius: 12px;

  background: #fff;
  color: #1e293b;

  font-family: 'Raleway', sans-serif;
  outline: none;

  transition: border-color .2s, box-shadow .2s;
}

.hl-inp:focus {
  border-color: #fff000;
  box-shadow: 0 0 0 4px rgba(255,240,0,.12);
}

.hl-pw-wrap {
  position: relative;
}

.hl-eye {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);

  background: none;
  border: none;

  color: #94a3b8;
  cursor: pointer;

  font-size: .84rem;
  padding: 4px;

  transition: color .15s;
  line-height: 1;
}

.hl-eye:hover {
  color: #000000;
}

.hl-row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 24px;
}

.hl-ck-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hl-ck {
  width: 15px;
  height: 15px;

  accent-color: #000000;
  cursor: pointer;
}

.hl-ck-lbl {
  font-size: .8rem;
  color: #64748b;

  cursor: pointer;
  font-weight: 500;
}

.hl-forgot {
  font-size: .8rem;
  font-weight: 700;

  color: #000000;
  text-decoration: none;

  transition: color .15s;
}

.hl-forgot:hover {
  color: #fff000;
}

.hl-btn {
  width: 100%;
  padding: 14px;

  font-size: .92rem;
  font-weight: 800;

  background: linear-gradient(135deg, #fff000, #fff000);
  color: #000000;

  border: none;
  border-radius: 12px;

  cursor: pointer;
  font-family: 'Raleway', sans-serif;

  transition: all .2s;

  box-shadow: 0 6px 22px rgba(255,240,0,.35);

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  letter-spacing: -.01em;
}

.hl-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 36px rgba(255,240,0,.45);
  filter: brightness(1.05);
}

.hl-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
  transform: none;
}

@keyframes hl-spin {
  to {
    transform: rotate(360deg);
  }
}

.hl-spin {
  display: inline-block;
  width: 14px;
  height: 14px;

  border: 2.5px solid rgba(0,0,0,.2);
  border-top-color: #000000;
  border-radius: 50%;

  animation: hl-spin .7s linear infinite;
}

.hl-div {
  display: flex;
  align-items: center;
  gap: 12px;

  margin: 26px 0;
}

.hl-div-line {
  flex: 1;
  height: 1px;
  background: #e2e8f0;
}

.hl-div-txt {
  font-size: .68rem;
  font-weight: 700;

  color: #94a3b8;

  text-transform: uppercase;
  letter-spacing: .08em;
}

.hl-signup {
  text-align: center;
  font-size: .83rem;
  color: #64748b;
}

.hl-signup a {
  color: #000000;
  font-weight: 800;

  text-decoration: none;
  border-bottom: 2px solid #fff000;

  padding-bottom: 1px;
  transition: color .15s;
}

.hl-signup a:hover {
  color: #fff000;
}

/* ───────────────── MOBILE ───────────────── */

@media (max-width: 780px) {

  .hl-root {
    grid-template-columns: 1fr;
  }

  .hl-left {
    display: none;
  }

  .hl-right {
    padding: 44px 24px;
    background: #fff;
  }
}

@media (max-width: 420px) {
  .hl-right {
    padding: 32px 18px;
  }

  .hl-title {
    font-size: 1.6rem;
  }

  .hl-btn, .hl-inp {
    font-size: 1rem;
  }

  .hl-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
`;

const HireLogin = () => {

  const [form, setForm] = useState({
    email: '',
    password: '',
    remember: false
  });

  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { login } = useAuth();

  const fromPath = location.state?.from?.pathname;

  const from =
    fromPath && fromPath !== '/HireLogin'
      ? fromPath
      : '/hire';

  const handleChange = (e) => {

    const {
      id,
      value,
      type,
      checked
    } = e.target;

    setForm(prev => ({
      ...prev,
      [id]:
        type === 'checkbox'
          ? checked
          : value
    }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!form.email || !form.password) {
      setError('Both fields are required.');
      return;
    }

    setLoading(true);
    setError('');

    try {

      await api.post('/client-login/', {
        email: form.email,
        password: form.password,
        remember: form.remember
      });

      await login();

      navigate(from, { replace: true });

    } catch (err) {

      setError(
        err.response?.data?.detail ||
        'Incorrect email or password.'
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{CSS}</style>

      <div className="hl-root">

        {/* LEFT PANEL */}
        <div className="hl-left">

          <h1 className="hl-headline">
            Hire skilled
            <br />
            craftsmen.
            <br />
            <em>Get it done right.</em>
          </h1>

          <p className="hl-desc">
            Kenya's verified marketplace for craftsmen and artisans.
            Browse portfolios, read reviews, and hire directly.
          </p>

          <ul className="hl-perks">

            {[
              'Every craftsman is manually verified',
              'Real portfolios & honest reviews',
              'Direct hire — no commission for clients',
              'Track your job from request to completion',
            ].map((text, i) => (

              <li className="hl-perk" key={i}>

                <span className="hl-tick">
                  <i className="fas fa-check" />
                </span>

                {text}

              </li>
            ))}
          </ul>
        </div>

        {/* RIGHT PANEL */}
        <div className="hl-right">

          <div className="hl-box">

            <h2 className="hl-title">
              Welcome back
            </h2>

            <p className="hl-sub">
              Log in to your client account
            </p>

            {error && (
              <div className="hl-err">
                <i className="fas fa-exclamation-circle" />
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>

              {/* EMAIL */}
              <div className="hl-field">

                <label
                  className="hl-lbl"
                  htmlFor="email"
                >
                  Email address
                </label>

                <input
                  id="email"
                  type="email"
                  className="hl-inp"

                  placeholder="you@example.com"

                  value={form.email}
                  onChange={handleChange}

                  required
                  disabled={loading}

                  autoComplete="email"
                />

              </div>

              {/* PASSWORD */}
              <div className="hl-field">

                <label
                  className="hl-lbl"
                  htmlFor="password"
                >
                  Password
                </label>

                <div className="hl-pw-wrap">

                  <input
                    id="password"

                    type={
                      showPw
                        ? 'text'
                        : 'password'
                    }

                    className="hl-inp"

                    placeholder="••••••••"

                    value={form.password}
                    onChange={handleChange}

                    required
                    disabled={loading}

                    style={{ paddingRight: 44 }}

                    autoComplete="current-password"
                  />

                  <button
                    type="button"
                    className="hl-eye"
                    onClick={() =>
                      setShowPw(!showPw)
                    }
                    tabIndex="-1"
                  >
                    <i
                      className={`fas ${
                        showPw
                          ? 'fa-eye-slash'
                          : 'fa-eye'
                      }`}
                    />
                  </button>

                </div>
              </div>

              {/* REMEMBER + FORGOT */}
              <div className="hl-row">

                <div className="hl-ck-wrap">

                  <input
                    id="remember"
                    type="checkbox"
                    className="hl-ck"

                    checked={form.remember}
                    onChange={handleChange}
                  />

                  <label
                    className="hl-ck-lbl"
                    htmlFor="remember"
                  >
                    Keep me logged in
                  </label>

                </div>

                <Link
                  to="/forgot-password"
                  className="hl-forgot"
                >
                  Forgot password?
                </Link>

              </div>

              {/* LOGIN BUTTON */}
              <button
                type="submit"
                className="hl-btn"
                disabled={loading}
              >

                {loading ? (
                  <>
                    <span className="hl-spin" />
                    Logging in…
                  </>
                ) : (
                  <>
                    <i className="fas fa-arrow-right-to-bracket" />
                    Log in
                  </>
                )}

              </button>

            </form>

            {/* DIVIDER */}
            <div className="hl-div">

              <div className="hl-div-line" />

              <span className="hl-div-txt">
                New here?
              </span>

              <div className="hl-div-line" />

            </div>

            {/* SIGNUP */}
            <p className="hl-signup">

              No account yet?{" "}

              <Link to="/HireSignup">
                Create one — it's free
              </Link>

            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default HireLogin;
